module.exports = __webpack_public_path__ + "2019-salary-guide-aq.jpg";